import { render } from "./ApproveApproval.vue?vue&type=template&id=150cfbb0&scoped=true"
import script from "./ApproveApproval.vue?vue&type=script&lang=js"
export * from "./ApproveApproval.vue?vue&type=script&lang=js"

import "./ApproveApproval.vue?vue&type=style&index=0&id=150cfbb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150cfbb0"]])

export default __exports__